#import "../fragments/sms-broadcast-engagement-stats-fragment.graphql"

query GetSmsBroadcastEngagementStats(
    $archived: Boolean
    $statuses: [EditionStatus!]!
    $assigneeIds: [ID!]
    $lastUpdatedTime: String
    $creatorUserId: String
    $search: String
) {
    smsBroadcasts(
        archived: $archived
        statuses: $statuses
        assigneeIds: $assigneeIds
        modifiedSinceTime: $lastUpdatedTime
        creatorUserId: $creatorUserId
        search: $search
    ) {
        ...SmsBroadcastEngagementStatsFragment
    }
}
